import React, {Fragment, Suspense} from 'react';
import MasterLayout from "../../components/MasterLayout/MasterLayout";
import LazyLoader from "../../components/MasterLayout/LazyLoader";
import EmployeeSalesTargetCreate from '../../components/EmployeeSalesTarget/EmployeeSalesTargetCreate';

const EmployeeSalesTargetCreatePage = () => {
    return (
        <Fragment>
            <MasterLayout>
                <Suspense fallback={<LazyLoader/>}>
                    <EmployeeSalesTargetCreate/>
                </Suspense>
            </MasterLayout>
        </Fragment>
    );
};

export default EmployeeSalesTargetCreatePage;